export const TIPO_LABELS = {
  LINK_EXTERNO: {
    label: "Link Externo",
    description: "Abre uma URL informada",
    icon: "cil-link",
    destinoLabel: "URL Destino",
    novaAba: true,
  },
  VIDEO_YOUTUBE: {
    label: "Vídeo Youtube",
    description: "Exibe um vídeo do Youtube",
    icon: "cil-video",
    destinoLabel: "Código do vídeo",
    novaAba: false,
  },
  LINK_INTEGRADO: {
    label: "Link Integrado",
    description: "Aponta para um link integrado cadastrado",
    icon: "cil-share-alt",
    destinoLabel: "Link Integrado",
    novaAba: false,
  },
};

/**
 * Cada local de exibição habilita um conjunto diferente de campos e tem seu
 * próprio tamanho recomendado de imagem. Antes essa regra estava espalhada
 * entre `inputShouldBeVisible()` e dois computed de tamanho no formulário.
 */
export const LOCAL_LABELS = {
  HOME: {
    label: "Home",
    description: "Carrossel da página inicial",
    icon: "cil-home",
    campos: [
      "tipoMidia",
      "destino",
      "novaAba",
      "popup",
      "ordem",
      "imagemMobile",
      "sistemas",
    ],
    tamanhoDesktop: "1500 x 500 px",
    tamanhoMobile: "500 x 300 px",
  },
  PDF: {
    label: "PDF cabeçalho",
    description: "Cabeçalho do PDF de orçamento/pedido",
    icon: "cil-file",
    campos: [],
    tamanhoDesktop: "800 x 150 px",
    tamanhoMobile: null,
  },
  PDF_RODAPE: {
    label: "PDF rodapé",
    description: "Rodapé do PDF de orçamento/pedido",
    icon: "cil-file",
    campos: [],
    tamanhoDesktop: "1387 x 55 px",
    tamanhoMobile: null,
  },
  SUGESTAO: {
    label: "Sugestão pedido",
    description: "Tela de sugestão de pedido",
    icon: "cil-cart",
    campos: ["imagemMobile", "sistemas"],
    tamanhoDesktop: "1500 x 300 px",
    tamanhoMobile: "500 x 300 px",
  },
  CASHBACK_CHECKOUT: {
    label: "Cashback checkout",
    description: "Etapa de cashback no checkout",
    icon: "cil-credit-card",
    campos: ["imagemMobile", "sistemas"],
    tamanhoDesktop: "720 x 800 px",
    tamanhoMobile: "720 x 800 px",
  },
  HOME_INSTITUCIONAL: {
    label: "Faixa institucional",
    description: "Faixa acima das categorias da página inicial",
    icon: "cil-bullhorn",
    campos: [
      "tipoMidia",
      "destino",
      "novaAba",
      "ordem",
      "imagemMobile",
      "sistemas",
    ],
    tamanhoDesktop: "1500 x 200 px",
    tamanhoMobile: "750 x 250 px",
    sistemas: ["B2B", "B2B_APP", "B2B_APP_CLIENTE_FINAL"],
  },
};

export function getTipoLabel(codigo) {
  return TIPO_LABELS[codigo]?.label || codigo;
}

export function getLocalLabel(codigo) {
  return LOCAL_LABELS[codigo]?.label || codigo;
}

export function getDestinoLabel(tipo) {
  return TIPO_LABELS[tipo]?.destinoLabel || "URL Destino";
}

export function getNovaAbaPadrao(tipo) {
  return TIPO_LABELS[tipo]?.novaAba ?? false;
}

export function campoVisivel(local, campo) {
  return (LOCAL_LABELS[local]?.campos || []).includes(campo);
}

export function sistemasDoLocal(local, sistemas) {
  const lista = Array.isArray(sistemas) ? sistemas : Object.values(sistemas || {});
  const permitidos = LOCAL_LABELS[local]?.sistemas;

  if (!permitidos) {
    return lista;
  }

  return lista.filter((sistema) => permitidos.includes(sistema.chave));
}

export function sistemasSelecionadosDoLocal(local, idsSelecionados, sistemas) {
  const selecionados = idsSelecionados || [];
  const lista = Array.isArray(sistemas) ? sistemas : Object.values(sistemas || {});

  if (!LOCAL_LABELS[local]?.sistemas || !lista.length) {
    return selecionados;
  }

  const permitidos = sistemasDoLocal(local, lista).map((sistema) => sistema.id);

  return selecionados.filter((id) => permitidos.includes(id));
}

export function getTamanhoDesktop(local) {
  const tamanho = LOCAL_LABELS[local]?.tamanhoDesktop;
  return tamanho
    ? `Imagem desktop (Recomendado ${tamanho})`
    : "Imagem desktop";
}

export function getTamanhoMobile(local) {
  const tamanho = LOCAL_LABELS[local]?.tamanhoMobile;
  return tamanho ? `Imagem mobile (Recomendado ${tamanho})` : "Imagem mobile";
}

export const TIPOS = Object.keys(TIPO_LABELS).map((key) => ({
  key,
  ...TIPO_LABELS[key],
}));

export const LOCAIS = Object.keys(LOCAL_LABELS).map((key) => ({
  key,
  ...LOCAL_LABELS[key],
}));
